﻿export function combine(...parts: string[]): string {
    return parts.reduce((url, part) => {
        if(!url.endsWith('/') && url.length > 0)
            url += '/';
        url += part;
        return url;
    }, '');
}